export function generatePINumber() {
  const now    = new Date();
  const YY     = String(now.getFullYear()).slice(-2);
  const MM     = String(now.getMonth() + 1).padStart(2, "0");
  const XXX    = String(Math.floor(Math.random() * 900) + 100); // 100–999
  const XX     = String(Math.floor(Math.random() * 90)  + 10);  // 10–99
  return `RR/${YY}/${XXX}-${MM}-${XX}`;
  // e.g. → RR/26/347-03-58
}